const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const createWebhookBin = async () => {
  const response = await fetch(`${API_URL}/api/bins`, { method: 'POST' })
  if (!response.ok) throw new Error('Não foi possível criar o endpoint.')
  return response.json()
}

export const fetchWebhookRequests = async (id) => {
  const response = await fetch(`${API_URL}/api/bins/${id}/requests`)
  if (!response.ok) throw new Error('Bin não encontrado.')
  return response.json()
}

export const webhookStreamUrl = (id) => `${API_URL}/api/bins/${id}/stream`

export const webhookCaptureUrl = (id) => `${API_URL}/hooks/${id}`
